import { animate, style, transition, trigger } from '@angular/animations';

export const noOpAnimation: any[] = [
  trigger('noOpAnimation', [
    transition('void => *', [
      style({ opacity: 1 }),
      animate('500ms ease-in-out')
    ]),
    transition('* => void', [
      animate('500ms ease-in-out', style({ opacity: 1 }))
    ])
  ])
];

export const weekSelectorAnimation: any[] =[
  trigger('openCloseCalendar', [
    transition(':enter', [
      style({
        opacity: 0,
        transform: 'scale(.5)',
        transformOrigin: '0 0',
      }),
      animate(
        '150ms cubic-bezier(.4, 0, .2, 1)',
        style({
          opacity: 1,
          transform: 'scale(1)',
          transformOrigin: '0 0',
        })
      ),
    ]),
    transition(':leave', [
      animate(
        '150ms cubic-bezier(.4, 0, .2, 1)',
        style({
          opacity: 0,
          transform: 'scale(.5)',
          transformOrigin: '0 0',
        })
      ),
    ]),
  ])
];